import { Path } from '@/main/router/routerPath';

import Edit from './Edit.vue';
import List from './List.vue';
import { NAME, CRUMB_LABEL_EDIT } from './constants';
import { PROrdersParts } from './parts';

export const router = new Path().addChildren([
	new Path(NAME, { List, Edit, SelectList: List }, CRUMB_LABEL_EDIT),
	PROrdersParts.router,
]);
